module.exports = __webpack_public_path__ + "static/img/title.2b87a67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/peterschmid/title.jpg
// module id = 439
// module chunks = 1